import * as React from "react";
import { Paper, Box, Divider, List, ListItem } from "@mui/material";
import { HeaderNavProps } from "@/components/header/common/types";

import SecondaryPane from "@/components/header/navigation/desktop/_components/secondary-navigation/secondary-pane";

type SecondaryNavigationProps = {
  secondaryNavItems: HeaderNavProps[];
  setTertiaryNavItems: (destination: HeaderNavProps[]) => void;
  setTertiaryHeaderLabel: (label: string) => void;
  setTertiaryHeaderLearnMoreUrl: (url: string) => void;
  setTertiaryHeaderViewAllDestinationsUrl: (url: string) => void;
};
export default function SecondaryNavigation(props: SecondaryNavigationProps) {
  const { secondaryNavItems, setTertiaryNavItems, setTertiaryHeaderLabel, setTertiaryHeaderLearnMoreUrl, setTertiaryHeaderViewAllDestinationsUrl } = props;

  return (
    <Paper
      className="Sidebar"
      sx={{
        backgroundColor: "background.default",
        position: "sticky",
        transform: {
          xs: "translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1)))",
          md: "none"
        },
        top: 0,
        maxHeight: "inherit",
        borderBottomLeftRadius: "8px"
      }}
    >
      <Box
        sx={{
          minHeight: 0,
          width: "100%",
          overflow: "hidden auto",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          maxHeight: "inherit",
          borderBottomLeftRadius: "8px"
        }}
      >
        <List
          sx={{
            overflow: "hidden",
            "--List-nestedInsetStart": "20px",
            maxHeight: "inherit",
            borderBottomLeftRadius: "8px"
          }}
        >
          <ListItem
            sx={{              
              padding: 0
            }}
          >
          <SecondaryPane
            secondaryNavItems={secondaryNavItems}
            setTertiaryNavItems={setTertiaryNavItems}
            setTertiaryHeaderLabel={setTertiaryHeaderLabel}
            setTertiaryHeaderLearnMoreUrl={setTertiaryHeaderLearnMoreUrl}
            setTertiaryHeaderViewAllDestinationsUrl={setTertiaryHeaderViewAllDestinationsUrl}
          />
          </ListItem>
        </List>
      </Box>
      <Divider />
    </Paper>
  );
}
